import { authRoles } from "../../../auth/authRoles";
import AnakPerusahaan from "./AnakPerusahaan";
import EditAnakPerusahaan from "./EditAnakPerusahaan";
import TambahAnakPerusahaan from "./TambahAnakPerusahaan";

const anakPerusahaanRoute = [
  {
    path: "/anak_perusahaan/edit/:id",
    exact: true,
    component: EditAnakPerusahaan,
    auth: authRoles.all,
  },
  {
    path: "/anak_perusahaan/tambah",
    exact: true,
    component: TambahAnakPerusahaan,
    auth: authRoles.all,
  },
  {
    path: "/anak_perusahaan",
    exact: true,
    component: AnakPerusahaan,
    auth: authRoles.all,
  },
];

export default anakPerusahaanRoute;
